"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAccountScreenBase = void 0;
var react_1 = __importStar(require("react"));
var WorkflowCard_1 = require("../../components/WorkflowCard");
var WorkflowCardActions_1 = require("../../components/WorkflowCard/WorkflowCardActions");
var WorkflowCardBody_1 = require("../../components/WorkflowCard/WorkflowCardBody");
var WorkflowCardHeader_1 = require("../../components/WorkflowCard/WorkflowCardHeader");
var WorkflowCardInstructions_1 = require("../../components/WorkflowCard/WorkflowCardInstructions");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var ErrorManager_1 = __importDefault(require("../../components/Error/ErrorManager"));
/**
 * Component that renders a screen for the user to enter their email address to start the
 * account creation process.
 *
 * @param emailLabel label for the email field
 * @param initialValue initial value for the email text field
 * @param emailValidator function used to test the input for valid formatting
 * @param emailTextFieldProps props to pass to the email text field
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 *
 * @category Component
 */
var CreateAccountScreenBase = function (props) {
    var _a;
    var 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _b = props.emailValidator, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    emailValidator = _b === void 0 ? function (email) { return true; } : _b, emailLabel = props.emailLabel, initialValue = props.initialValue, emailTextFieldProps = props.emailTextFieldProps, inputRef = props.inputRef, errorDisplayConfig = props.errorDisplayConfig;
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    var _c = react_1.default.useState(initialValue ? initialValue : ''), emailInput = _c[0], setEmailInput = _c[1];
    var _d = react_1.default.useState((_a = emailValidator(initialValue !== null && initialValue !== void 0 ? initialValue : '')) !== null && _a !== void 0 ? _a : false), isEmailValid = _d[0], setIsEmailValid = _d[1];
    var _e = react_1.default.useState(''), emailError = _e[0], setEmailError = _e[1];
    var _f = react_1.default.useState(false), shouldValidateEmail = _f[0], setShouldValidateEmail = _f[1];
    var handleEmailInputChange = (0, react_1.useCallback)(function (email) {
        setEmailInput(email);
        var emailValidatorResponse = emailValidator(email);
        setIsEmailValid(typeof emailValidatorResponse === 'boolean' ? emailValidatorResponse : false);
        setEmailError(typeof emailValidatorResponse === 'string' ? emailValidatorResponse : '');
    }, [emailValidator]);
    (0, react_1.useEffect)(function () {
        if (emailInput.length > 0) {
            setShouldValidateEmail(true);
            handleEmailInputChange(emailInput);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({}, cardBaseProps),
        react_1.default.createElement(WorkflowCardHeader_1.WorkflowCardHeader, __assign({}, headerProps)),
        react_1.default.createElement(WorkflowCardInstructions_1.WorkflowCardInstructions, __assign({}, instructionsProps)),
        react_1.default.createElement(WorkflowCardBody_1.WorkflowCardBody, null,
            react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig),
                react_1.default.createElement(TextField_1.default, __assign({ ref: inputRef, type: 'email', label: emailLabel, fullWidth: true, value: emailInput, variant: "filled", error: shouldValidateEmail && !isEmailValid, helperText: shouldValidateEmail && emailError }, emailTextFieldProps, { onChange: function (e) {
                        // eslint-disable-next-line no-unused-expressions
                        (emailTextFieldProps === null || emailTextFieldProps === void 0 ? void 0 : emailTextFieldProps.onChange) && emailTextFieldProps.onChange(e);
                        handleEmailInputChange(e.target.value);
                    }, onKeyUp: function (e) {
                        var _a;
                        if (e.key === 'Enter' &&
                            ((emailInput.length > 0 && isEmailValid) || actionsProps.canGoNext))
                            (_a = actionsProps === null || actionsProps === void 0 ? void 0 : actionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(actionsProps);
                    }, onBlur: function (e) {
                        // eslint-disable-next-line no-unused-expressions
                        (emailTextFieldProps === null || emailTextFieldProps === void 0 ? void 0 : emailTextFieldProps.onBlur) && emailTextFieldProps.onBlur(e);
                        setShouldValidateEmail(true);
                    } })))),
        react_1.default.createElement(WorkflowCardActions_1.WorkflowCardActions, __assign({}, actionsProps, { canGoNext: (emailInput.length > 0 && isEmailValid && actionsProps.canGoNext) }))));
};
exports.CreateAccountScreenBase = CreateAccountScreenBase;
